export const configDestinos = {

  PERU: {
    tipo: "simple",
    opciones: [5, 6, 7, 8]
  },

  JPN: {
    tipo: "simple",
    opciones: [9, 14]
  },

  BKK: {
    tipo: "simple",
    opciones: [12, 13]
  },

  "JPN GUIA": {
    tipo: "simple",
    opciones: [9, 14]
  },

  "HAV COMBINADO": {
    tipo: "combinado",
    labels: ["VAR", "HAV"],
    min1: 2,
    min2: 2
  },

  "PTY COMBINADO": {
    tipo: "combinado",
    labels: ["Playa", "Ciudad"],
    min1: 2,
    min2: 2
  },

  "MEX COMBINADO": {
    tipo: "combinado",
    labels: ["MEX", "CUN"],
    min1: 3,
    min2: 2
  }

}